/**
 * Stacked content-type usage bar + legend.
 *
 * Extracted verbatim from StorageFilesTab.jsx during the Phase 6 refactor
 * (no behaviour change).
 */
import { formatBytes } from '../../../utils/uploadImage';
import { shortType, colorForType } from './storageMeta';

export function ContentTypeBar({ rows, total }) {
  if (!rows.length || !total) return null;
  return (
    <div className="space-y-2">
      <div className="flex h-3 rounded-full overflow-hidden bg-muted">
        {rows.map(r => (
          <div
            key={r.content_type}
            style={{ width: `${(r.bytes / total) * 100}%`, backgroundColor: colorForType(r.content_type) }}
            title={`${r.content_type}: ${formatBytes(r.bytes)} (${r.count})`}
          />
        ))}
      </div>
      <div className="flex flex-wrap gap-3 text-xs">
        {rows.slice(0, 6).map(r => (
          <span key={r.content_type} className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full" style={{ backgroundColor: colorForType(r.content_type) }} />
            <span className="font-medium">{shortType(r.content_type)}</span>
            <span className="text-muted-foreground">{formatBytes(r.bytes)} · {r.count}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
